module.exports = __webpack_public_path__ + "files/2e1836bec1462792ff8f624286a6455c.png";